import React, {useCallback, useEffect, useRef, useState} from "react";
import AutocompleteTextInput, {DataType} from "../../shared/AutocompleteTextInput";
import DatePicker from "../../shared/DatePicker";
import {memberTransactionList} from "../../api/RestCallHelper";
import {validateForm} from "../../utils/ValidationUtil";
import {useHistory, useLocation} from "react-router-dom";
import {FormButton} from "../../styles/globalStyles";
import {QueryTransactionsFormDiv} from "./TransactionQueryStyles";
import useFetchMembersDropdown from "../../hooks/useFetchMembersDropdown";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";

export default ({
    setTransactions
}) => {

    let history = useHistory();
    let location = useLocation();

    const dispatch = useFeedbackDispatch();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownData, loading] = useFetchMembersDropdown(dropdownOpen);

    const [formValidated, setFormValidated] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const [queryRequest, setQueryRequest] = useState({
        member: null,
        date: new Date(new Date().getFullYear(), 0, 1)
    });

    const close = (event, reason) => {
        console.log("In ClaimsForm close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    const submit = useCallback(async () => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        console.log(queryRequest)
        // send the actual request
        await memberTransactionList(queryRequest, setTransactions, dispatch, close, history, location);

        // once the request is sent, update state again
        if (isMounted.current){
            // only update if we are still mounted
            setIsSending(false);
        }

    }, [isSending, location, isMounted, queryRequest]);

    useEffect(() => {
        setFormValidated(validateForm(queryRequest));
        console.log("request", queryRequest);
    }, [queryRequest, formValidated]);

    const clear = () => {
        setQueryRequest({
            member: null,
            date: null
        });
        setTransactions(null);
    }

    return (

        <QueryTransactionsFormDiv>


            <AutocompleteTextInput
                label = "Select Member"
                value = {queryRequest.member}
                onChange = {(value) => setQueryRequest({...queryRequest , member: value})}
                optionsList = {dropdownData}
                loading = {loading}
                open = {dropdownOpen}
                setOpen = {setDropdownOpen}
                dataType = {DataType.MEMBER}
            />

            <DatePicker
                label="From Date"
                value={queryRequest.date}
                onChange={(value) => setQueryRequest({ ...queryRequest, date: value }) }
                style={{ margin: "10px" }}
            />

            {formValidated &&
                <>
                    <FormButton
                        disabled={isSending}
                        onClick={submit}
                    >
                        Go
                    </FormButton>
                    <FormButton
                        onClick={clear}
                        disabled={isSending}
                    >
                        Clear
                    </FormButton>
                </>

            }

        </QueryTransactionsFormDiv>
    );
}